module.exports = __webpack_public_path__ + "static/media/logo-okptf.7c17893d.png";